var _excluded = ["isOpen", "onClose", "onCloseComplete", "data-testid", "closeButtonAriaLabel", "header", "body", "footer", "isLoading"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { forwardRef } from 'react';
import { Divider } from '../../components/dataDisplay';
import { Container } from '../Container';
import { LoadingContainer } from '../LoadingContainer';
import { DrawerBody, DrawerCloseButton, DrawerContent, DrawerFooter, DrawerHeader } from './components';
import { DrawerContext } from './DrawerContext';
import { useDrawer } from './useDrawer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var Drawer = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
    isOpen,
    onClose,
    onCloseComplete,
    'data-testid': dataTestId,
    closeButtonAriaLabel,
    header,
    body,
    footer,
    isLoading
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(DrawerContext.Provider, {
    value: useDrawer({
      isOpen,
      onClose,
      onCloseComplete,
      'data-testid': dataTestId,
      closeButtonAriaLabel
    }),
    children: /*#__PURE__*/_jsxs(DrawerContent, _objectSpread(_objectSpread({
      "data-component": "Drawer",
      ref: ref
    }, otherProps), {}, {
      children: [/*#__PURE__*/_jsxs(DrawerHeader, {
        "data-component": "DrawerHeader",
        children: [/*#__PURE__*/_jsx(DrawerCloseButton, {
          "data-component": "DrawerCloseButton"
        }), /*#__PURE__*/_jsx(Container, {
          width: "full",
          children: header
        })]
      }), /*#__PURE__*/_jsx(Divider, {}), isLoading ? /*#__PURE__*/_jsx(LoadingContainer, {
        isLoading: true
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(DrawerBody, {
          "data-component": "DrawerBody",
          children: body
        }), footer && /*#__PURE__*/_jsx(DrawerFooter, {
          "data-component": "DrawerFooter",
          children: footer
        })]
      })]
    }))
  });
});
Drawer.displayName = 'Drawer';
//# sourceMappingURL=Drawer.js.map